
export type RecentOrderResponseOrdersItem = {
  amount?: number;
  createdAt?: string;
  orderId?: string;
  productName?: string;
  status?: string;
};
